
	//门店名称 联系人 联系电话 公司地址 有效期 
	const columnList: Array<any> = [
		[
			{
				prop: "basicset_name",
				label: "名称",
				width: 200,
			},
			{
				prop: "basicset_order",
				label: "排序",
				width: 100,
			},
		],
		[
			{
				prop: "basicset_name",
				label: "名称",
				width: 200,
			},
			{
				prop: "basicset_order",
				label: "排序",
				width: 100,
			},
		],
		[
			{
				prop: "basicset_name",
				label: "名称",
				width: 200,
			},
			{
				prop: "basicset_order",
				label: "排序",
				width: 100,
			},
		]
	    
	];
	
	import {
		defineComponent,
		ref,
		reactive,
		inject,
		provide,
		onMounted,
		watch
	} from "vue";
	import { useRoute, useRouter } from 'vue-router'
    import { storeUser } from "@/store/User";
    import {getframeworkList, permissionList} from "@/api/http";
	import {column} from "@/assets/types/common";
import axios from "axios";
import { Request } from "@/api/request";
	
	
	export default defineComponent({
	    name: "insurance",
		setup() {
		        const setTitle: any = inject("setTitle");
		        setTitle(["服务分类"]);
		        let pageSize = ref(10),
		            currentPage = ref(1),
                    user = storeUser.getUser(),
                    NavIndex = ref(2),//服务分类
                    total = ref(0),
		            tableData = ref([] as Array<any>),
		            loading = ref(true),
                    roleList = ref({} as any),
					headClass = inject("headClass"),
					dialog_model = ref(""),
					formRef = ref(null),
					form = ref({} as any),
					dialog_index = ref(0),
					Router = useRouter(),
					screenParameter: any = {
						page: currentPage.value,
						pagesize: pageSize.value,
					},
                    // 切换每页数量大小
                    handleSizeChange = (size: number): void => {
                        pageSize.value = size;
                        getTableData();
                    },
                    // 切换分页
                    handleCurrentChange = (page: number): void => {
                        currentPage.value = page;
                        getTableData();
                    },
		            getTableData = (): void => {
		                loading.value = true;
                        let mydata = {
                            type:1,
                            role_name:'serviceType',
                        };
                        permissionList(mydata).then((res:any)=>{
                            roleList.value = res?.content?.list || 0;
                        });
						screenParameter['page'] = currentPage.value
						screenParameter['pagesize'] = pageSize.value
                        Request.axiosInstance({
                            url: 'adminapi/Basicset/list',
                            data: {
                                basicset_type: NavIndex.value,
                                ...screenParameter
                            }
                        }).then((res: any) => {
		                    tableData.value = res?.content?.list || [];
		                    total.value = res.content.total;
		                    loading.value = false;
		                });
		            },
					_option = (id: number, text: string) => {
						
					
						Router.push({
							path: '/framework/' + text,
							query: {
								id: id
							}
						})
					
					},
					_upState =(id: number, status: number) => {
						Request.axiosInstance({
							url:　'adminapi/Basicset/upState',
							data: {
								basicset_id: id,
								status: status, 
								basicset_type: NavIndex.value
							}
						}).then((res: any) => {
		                    res.status == 202 && getTableData()
		                });
					},
					_submitForm = () => {
						(formRef.value as any).validate((valid: boolean) => {
                    		if (!valid) return
							Request.axiosInstance({
								url:  dialog_model.value == 'edit' ? 'adminapi/Basicset/edit' :  'adminapi/Basicset/create' ,
								data: form.value
							}).then((res: any) => {
								res.status == 202 && (getTableData(), dialog_model.value ='')
							})
						})
					}
			
					
					
		        onMounted(() => {
					
							
					var router = useRoute();
					console.log(router)
						
				
					
					getTableData()
		        });
				

				watch(dialog_model, (newval, oldval) => {
					if(newval == 'add')
					{
						form.value ={
							basicset_name: '',
							basicset_order: '',
							basicset_type: NavIndex.value
						}
					
					}
					else if(newval == 'edit')
					{
						form.value ={
							basicset_id: tableData.value[dialog_index.value].basicset_id,
							basicset_name: tableData.value[dialog_index.value].basicset_name,
							basicset_order: tableData.value[dialog_index.value].basicset_order,
							basicset_type: tableData.value[dialog_index.value].basicset_type,
						}
					}
				})
				
		        return {
		            columnList,
		            tableData,
		            loading,
					headClass,
					screenParameter,
					Router,
					_option,
                    NavIndex,
					_upState,
					dialog_model,
					dialog_index,
					form,
					formRef,
					_submitForm,
                    roleList,
                    handleCurrentChange,
                    handleSizeChange,
                    currentPage,
                    pageSize,
                    total,
                    user
		        };
		    },
		});
		
